export default {
	close: '关闭'
};
